
import React, {useEffect, useState} from 'react';
import {Button, Col, Row, Table} from 'react-bootstrap';

import styles from './intro.module.scss';
import Loading from "../../../../components/loading/loading";
import {Security} from "../../../../models/security";
import Order from "../../../../models/order";
import {REDUCER_ACTION_INITIALIZE} from "../../../../context/security-context";
import UserService from "../../../../services/user-service";
import ModalCustom from "../../../../components/modal/modal";
import {ISSUER_ROLE} from "../../../../helpr/constants";


const Intro = (props) => {
  const { securityName, sellingAgentDisplayName, securityOfferDate,
    securityIssuer, securityOfferCloseDate, sessionTimeRemaining } = props.session;

  const userService = new UserService();
  const [loading, setLoading] = useState(false);
  const [video, setVideo] = useState();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const initializeTrainingVideo = async () => {
      setLoading(true)
      try{
        let video = await userService.getApplicantTrainingVideoUrl();
       setVideo(video.presignedUrl)
      } catch(error){
      } finally {
        setLoading(false);
      }
    }
    initializeTrainingVideo()
    // eslint-disable-next-line
  }, []);

  //Handle redirect to privacy notice
  const redirectToPrivacyNotice = () => {
    const newWindow = window.open(`${process.env.REACT_APP_CLIENT_ENDPOINT}/privacy-notice`, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
  }

  const redirectToTerms = () => {
    const newWindow = window.open(`${process.env.REACT_APP_CLIENT_ENDPOINT}/terms-conditions`, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
  }

  const showFAQ = () => {
    setShow(true)
  }

  return (
    <>
      <div className={styles['intro-component']}>
        <div className={styles['intro-component-header']}>
          WELCOME TO THE {process.env.REACT_APP_TITLE}!
        </div>
        <div className={styles['intro-component-text-body']}>
          Thank you for your interest to apply for a reservation in <span className={styles['highlight']}>{securityName}</span>.
        </div>
        <Row>
          <Col sm={12} lg={6}>
            <div className={styles['intro-component-text-body']}>
              <div className={styles['highlight']}>
                Security Details:
              </div>
              <div> Security Name: {securityName} </div>
              <div> Security Issuer: {securityIssuer} </div>
              <div> Selling Agent: {sellingAgentDisplayName} </div>
              <div> Security Offer Date: {securityOfferDate} </div>
              <div> Security Offer Close Date: {securityOfferCloseDate} </div>
            </div>
          </Col>
          <Col sm={12} lg={6}>
            { renderTrainingVideo(loading, video) }
          </Col>
        </Row>
        <div className={styles['intro-component-text-body']}>
          <div>
            By clicking <span className={styles['bold']}>CONTINUE</span>, I agree to the {process.env.REACT_APP_TITLE} <span className={styles['link']} onClick={() => redirectToTerms()}>Terms of Use</span>{' '}
            and consent to the collection and processing of my personal data as described
            in the <span className={styles['link']} onClick={() => redirectToPrivacyNotice()}>Privacy Notice</span>.
          </div>
        </div>
        <div className={styles['action']}>
          <div className={styles['time-left']}>
            You have {sessionTimeRemaining.split('.')[0]} left to accomplish your reservation.
          </div>
          <div className={styles['button']}>
            <Button onClick={()=>{props.investButtonAction()}}>CONTINUE</Button>
          </div>
          <div className={styles['need-help']}>
            <label><a href='#' onClick={showFAQ} >Need help?</a></label>
          </div>
        </div>
      </div>
      <ModalCustom
        show={show}
        title={'Frequently Asked Questions'}
        onClose={() => setShow(false)}
        component={renderFAQ()}
        style={styles['faq-modal']} />
    </>
  )
}

const renderTrainingVideo = (loading, url) => {
  return loading ? <Loading fullscreen={true}/> : (
    <div class={'video'}>
      <video class={'video'} controls >
        <source src={url} type="video/mp4" />
        Sorry, your browser doesn't support embedded videos.
      </video>
    </div>
  )
}

const renderFAQ = () => {
  return (
    <div className={styles['faq']}>
      <Row>
        <Col lg={12}>
          <Row>
            <Col lg={12}>
              <Table className={styles['table']} responsive>
                <thead className={styles['white-color']} >
                  <tr>
                    <th>Question</th>
                    <th>Answer</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className={`${styles['white-color']} ${styles['question']}`}>
                      Will there be a fee charged to the
                      investor for using e-SIP to fill up
                      and submit an Application to
                      Purchase (ATP)?
                    </td>
                    <td className={styles['answer']}>
                      No. There is no fee for the use of the e-SIP to submit
                      applications to purchase securities.
                    </td>
                  </tr>
                  <tr>
                    <td className={`${styles['white-color']} ${styles['question']}`}>
                      How can I make/apply for my
                      reservation through e-SIP?
                    </td>
                    <td className={styles['answer']}>
                      To submit an application to purchase securities on the eSIP, please advise your Selling Agent of your intent. Your
                      Selling Agent will then email you a link to the e-SIP which
                      will direct you to an Application Form for you to
                      accomplish. When you press “Submit”, the form is sent
                      directly to your Selling Agent, who will inform you of the
                      application’s status.
                    </td>
                  </tr>
                  <tr>
                    <td className={`${styles['white-color']} ${styles['question']}`}>
                      Can I submit multiple applications
                      through different Selling Agents?
                    </td>
                    <td className={styles['answer']}>
                      Yes. As long as your selected Selling Agents are
                      participating in the Issue, they will be able to e-mail you
                      links to applications to purchase the security.
                    </td>
                  </tr>
                  <tr>
                    <td className={`${styles['white-color']} ${styles['question']}`}>
                      Is there a facility to view all the
                      ATPs or reservations I submitted
                      to all selling agents?
                    </td>
                    <td className={styles['answer']}>
                      No. This feature is not available for the current release.
                    </td>
                  </tr>
                  <tr>
                    <td className={`${styles['white-color']} ${styles['question']}`}>
                      If I canceled my reservation, can I
                      submit a new ATP or make
                      another reservation?
                    </td>
                    <td className={styles['answer']}>
                      Yes as long as it is within the allowed period of the offer.
                      Please coordinate changes or cancellations with your
                      Selling Agent.
                    </td>
                  </tr>
                  <tr>
                    <td className={`${styles['white-color']} ${styles['question']}`}>
                      Can I re-apply to purchase
                      another amount after canceling
                      my other application?
                    </td>
                    <td className={styles['answer']}>
                      Yes, you can re-apply for another amount through your
                      Selling Agent.
                    </td>
                  </tr>
                  <tr>
                    <td className={`${styles['white-color']} ${styles['question']}`}>
                      How do I gain access to the e-SIP?
                    </td>
                    <td className={styles['answer']}>
                      You can only gain access by asking your Selling Agent to
                      send you an invitation with the link to the e-SIP. The
                      invitation will be sent to the email account that you register
                      with your Selling Agent. For security purposes, the link will
                      expire after twelve (12) hours, after which you will have to
                      request for another invitation link from your Selling Agent.
                    </td>
                  </tr>
                  <tr>
                    <td className={`${styles['white-color']} ${styles['question']}`}>
                      Once I have accessed the e-SIP, is
                      there a time limit?
                    </td>
                    <td className={styles['answer']}>
                      For security purposes, after you have received the link in
                      your email, you will have one (1) hour to accomplish the
                      form. If you were not able to finish filling up the form, you
                      may request for another invitation link from your Selling
                      Agent/Broker.
                    </td>
                  </tr>
                  <tr>
                    <td className={`${styles['white-color']} ${styles['question']}`}>
                      Other than through e-SIP, is there
                      an alternative way to make a
                      reservation to purchase for a
                      particular bond?
                    </td>
                    <td className={styles['answer']}>
                      Yes. You may ask your Selling Agent how they can accept
                      your order. Each Selling Agent may have different
                      requirements. Your Selling Agent can then handle
                      uploading an electronic version of your application to
                      purchase to the e-SIP.
                    </td>
                  </tr>
                  <tr>
                    <td className={`${styles['white-color']} ${styles['question']}`}>
                      How will I be notified if my
                      reservation is approved?
                    </td>
                    <td className={styles['answer']}>
                      You will receive an email notification and a copy of the
                      Application to Purchase (ATP) from e-SIP.
                    </td>
                  </tr>
                  <tr>
                    <td className={`${styles['white-color']} ${styles['question']}`}>
                      Can I increase the amount of my
                      application submitted to my
                      Selling Agent through the e-SIP
                      portal?
                    </td>
                    <td className={styles['answer']}>
                      Yes. Should you wish to increase or add the amount of your
                      application to purchase, please contact your Selling Agent.
                      To implement the change, your Selling Agent will reject
                      your original application and ask you to fill up another
                      application form for the securities on offer.
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default Intro;


